var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.header,"items":_vm.data,"loading":_vm.loading2,"search":_vm.search,"mobile-breakpoint":"0"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }